/**
 * Everspring Wishlist Page
 *
 * Reads wishlist entries from localStorage (esWishlist), fetches each product
 * via /products/{handle}.json and renders them as es-product-card cards.
 */
(function () {
  'use strict';

  var strings = window.esCardStrings || {};
  var STORAGE_KEY = 'esWishlist';
  var grid = document.getElementById('EsWishlistGrid');
  var empty = document.getElementById('EsWishlistEmpty');
  var loading = document.getElementById('EsWishlistLoading');

  if (!grid) return;

  function getWishlist() {
    try {
      var raw = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
      if (raw.length > 0 && typeof raw[0] === 'string') {
        raw = raw.map(function (id) { return { id: id, handle: '' }; });
        saveWishlist(raw);
      }
      return raw;
    } catch (_) {
      return [];
    }
  }

  function saveWishlist(list) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
  }

  function showEmpty() {
    empty.style.display = '';
    loading.style.display = 'none';
    grid.style.display = 'none';
  }

  function showGrid() {
    empty.style.display = 'none';
    loading.style.display = 'none';
    grid.style.display = '';
  }

  /**
   * Fetch a single product by handle via the Shopify JSON API.
   */
  function fetchProductByHandle(handle) {
    if (!handle) return Promise.resolve(null);
    return fetch('/products/' + handle + '.json')
      .then(function (res) {
        if (!res.ok) return null;
        return res.json();
      })
      .then(function (data) {
        return data && data.product ? data.product : null;
      })
      .catch(function () {
        return null;
      });
  }

  /**
   * Build a product card HTML string matching the es-card-product snippet.
   */
  function buildCard(product) {
    var id = String(product.id);
    var handle = product.handle;
    var title = product.title;
    var url = '/products/' + handle;
    var firstVariant = product.variants && product.variants[0];
    var price = firstVariant ? firstVariant.price : '0.00';
    var comparePrice = firstVariant ? firstVariant.compare_at_price : null;
    var image = product.image ? product.image.src : (product.images && product.images[0] ? product.images[0].src : '');
    var available = product.available !== false && firstVariant && firstVariant.available;
    var variantId = firstVariant ? firstVariant.id : '';

    var hasSale = comparePrice && parseFloat(comparePrice) > parseFloat(price);
    var discountPct = hasSale
      ? Math.round(((parseFloat(comparePrice) - parseFloat(price)) / parseFloat(comparePrice)) * 100)
      : 0;

    var formattedPrice = formatMoney(price);
    var formattedCompare = hasSale ? formatMoney(comparePrice) : '';

    var imgHtml = image
      ? '<img src="' + getSizedImageUrl(image, '600x') + '" alt="' + escapeHtml(title) + '" class="es-product-card__img es-product-card__img--primary" loading="lazy" width="600" height="750">'
      : '<div class="es-product-card__placeholder"><svg viewBox="0 0 24 24" fill="none" stroke="#ccc" stroke-width="0.5"><rect width="24" height="24"/></svg></div>';

    var badgeHtml = '';
    if (hasSale) {
      badgeHtml = '<span class="es-product-card__badge">' + discountPct + '% ' + (strings.sale || 'Sale') + '</span>';
    } else if (!available) {
      badgeHtml = '<span class="es-product-card__badge es-product-card__badge--soldout">' + (strings.soldOut || 'Sold out') + '</span>';
    }

    var priceHtml = hasSale
      ? '<span class="es-product-card__price es-product-card__price--sale">' + formattedPrice + '</span><span class="es-product-card__price--compare">' + formattedCompare + '</span>'
      : '<span class="es-product-card__price">' + formattedPrice + '</span>';

    var atcHtml = '';
    if (available) {
      atcHtml =
        '<div class="es-product-card__atc">' +
          '<div class="es-product-card__qty">' +
            '<button class="es-product-card__qty-btn" data-qty-minus aria-label="' + (strings.decreaseQuantity || 'Decrease') + '" type="button">\u2212</button>' +
            '<input class="es-product-card__qty-input" type="number" value="1" min="1" max="99" data-qty-input aria-label="' + (strings.quantity || 'Quantity') + '">' +
            '<button class="es-product-card__qty-btn" data-qty-plus aria-label="' + (strings.increaseQuantity || 'Increase') + '" type="button">+</button>' +
          '</div>' +
          '<button class="es-product-card__atc-btn" data-atc-btn data-variant-id="' + variantId + '" type="button">' + (strings.addToCart || 'Add to cart') + '</button>' +
        '</div>';
    } else {
      atcHtml =
        '<div class="es-product-card__atc">' +
          '<button class="es-product-card__atc-btn es-product-card__atc-btn--disabled" disabled type="button">' + (strings.soldOut || 'Sold out') + '</button>' +
        '</div>';
    }

    return (
      '<div class="es-product-card" data-product-id="' + id + '" data-product-handle="' + escapeHtml(handle) + '">' +
        '<div class="es-product-card__media">' +
          '<a href="' + url + '" aria-label="' + escapeHtml(title) + '" tabindex="-1">' + imgHtml + '</a>' +
          badgeHtml +
          '<button class="es-product-card__wishlist is-active" aria-label="' + (strings.removeFromWishlist || 'Remove from wishlist') + '" data-wishlist-btn data-product-id="' + id + '">' +
            '<svg viewBox="0 0 24 24"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>' +
          '</button>' +
        '</div>' +
        '<div class="es-product-card__info">' +
          '<a href="' + url + '" class="es-product-card__title">' + escapeHtml(title) + '</a>' +
          '<div class="es-product-card__price-row">' + priceHtml + '</div>' +
          atcHtml +
        '</div>' +
      '</div>'
    );
  }

  function escapeHtml(str) {
    var div = document.createElement('div');
    div.appendChild(document.createTextNode(str));
    return div.innerHTML;
  }

  /**
   * Format price string to Euro display.
   * Shopify /products/{handle}.json returns price as "24.95" string.
   */
  function formatMoney(amount) {
    var num = parseFloat(amount);
    if (isNaN(num)) return '';
    return '\u20AC' + num.toFixed(2).replace('.', ',');
  }

  /**
   * Get a sized image URL from Shopify CDN.
   */
  function getSizedImageUrl(url, size) {
    if (!url) return '';
    if (url.indexOf('_' + size) !== -1) return url;
    var match = url.match(/\.(jpg|jpeg|png|gif|webp)(\?.*)?$/i);
    if (match) {
      return url.replace(match[0], '_' + size + '.' + match[1] + (match[2] || ''));
    }
    return url;
  }

  /**
   * Main: load and render wishlist products.
   */
  function loadWishlist() {
    var wishlist = getWishlist();

    if (wishlist.length === 0) {
      showEmpty();
      return;
    }

    // Filter out entries without a handle (legacy data)
    var withHandles = wishlist.filter(function (item) { return item.handle; });

    if (withHandles.length === 0) {
      showEmpty();
      return;
    }

    empty.style.display = 'none';
    loading.style.display = '';
    grid.style.display = 'none';

    var promises = withHandles.map(function (item) {
      return fetchProductByHandle(item.handle);
    });

    Promise.all(promises).then(function (products) {
      var validProducts = products.filter(function (p) { return p !== null; });

      if (validProducts.length === 0) {
        showEmpty();
        return;
      }

      grid.innerHTML = validProducts.map(buildCard).join('');
      showGrid();
      initGridDelegation();
    });
  }

  /**
   * Handle clicks within the wishlist grid (remove from wishlist, qty, atc).
   */
  function initGridDelegation() {
    if (grid._esWishlistInit) return;
    grid._esWishlistInit = true;

    grid.addEventListener('click', function (e) {
      var target = e.target;

      /* --- Wishlist toggle (remove) --- */
      var wishBtn = target.closest('[data-wishlist-btn]');
      if (wishBtn) {
        var id = wishBtn.dataset.productId;
        var card = wishBtn.closest('.es-product-card');
        var handle = card ? (card.dataset.productHandle || '') : '';
        var wishlist = getWishlist();
        // Match by ID (type-safe — legacy entries may store id as number,
        // dataset.productId is always a string) AND by handle as fallback.
        var idx = -1;
        for (var i = 0; i < wishlist.length; i++) {
          var item = wishlist[i];
          var itemId = (typeof item === 'object' && item) ? item.id : item;
          if (String(itemId) === String(id)) { idx = i; break; }
          if (handle && typeof item === 'object' && item.handle === handle) { idx = i; break; }
        }
        if (idx !== -1) {
          wishlist.splice(idx, 1);
          saveWishlist(wishlist);
          document.dispatchEvent(new CustomEvent('wishlist:updated'));
          // Also fire es:wishlist:changed so the bottom-nav badge etc. picks it up
          document.dispatchEvent(new CustomEvent('es:wishlist:changed', { detail: { count: wishlist.length } }));
        }
        if (card) {
          // Use a fallback timer in case transitionend doesn't fire
          // (some browsers skip it if the element is removed mid-transition,
          // or if a CSS transition was already running).
          var removed = false;
          var doRemove = function () {
            if (removed) return;
            removed = true;
            if (card.parentNode) card.parentNode.removeChild(card);
            if (grid.children.length === 0) {
              showEmpty();
            }
          };
          card.classList.add('es-product-card--removing');
          card.addEventListener('transitionend', doRemove, { once: true });
          setTimeout(doRemove, 400);
        }
        return;
      }

      /* --- Quantity minus --- */
      var minus = target.closest('[data-qty-minus]');
      if (minus) {
        var input = minus.closest('.es-product-card__qty').querySelector('[data-qty-input]');
        if (input) {
          var val = parseInt(input.value, 10);
          if (val > 1) input.value = val - 1;
        }
        return;
      }

      /* --- Quantity plus --- */
      var plus = target.closest('[data-qty-plus]');
      if (plus) {
        var input = plus.closest('.es-product-card__qty').querySelector('[data-qty-input]');
        if (input) {
          var val = parseInt(input.value, 10);
          if (val < 99) input.value = val + 1;
        }
        return;
      }

      /* --- Add to cart --- */
      var atcBtn = target.closest('[data-atc-btn]');
      if (atcBtn) {
        var card = atcBtn.closest('.es-product-card');
        var qtyInput = card ? card.querySelector('[data-qty-input]') : null;
        var variantId = atcBtn.dataset.variantId;
        var qty = qtyInput ? parseInt(qtyInput.value, 10) : 1;

        atcBtn.classList.add('is-loading');
        atcBtn.textContent = '...';

        // Use Dawn's product-form pattern
        var cartDrawer = document.querySelector('cart-drawer');
        var sectionsToFetch = [];
        if (cartDrawer && typeof cartDrawer.getSectionsToRender === 'function') {
          // Use .section (Shopify section id) — NOT .id (DOM element id)
          sectionsToFetch = cartDrawer.getSectionsToRender().map(function (s) { return s.section || s.id; });
        }

        var addBody = { items: [{ id: parseInt(variantId, 10), quantity: qty }] };
        if (sectionsToFetch.length) {
          addBody.sections = sectionsToFetch;
          addBody.sections_url = window.location.pathname;
        }

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(addBody),
        })
          .then(function (res) { return res.json(); })
          .then(function (parsedState) {
            if (parsedState.status) {
              atcBtn.classList.remove('is-loading');
              atcBtn.textContent = strings.tryAgain || 'Try again';
              console.error('[es-wishlist] cart/add error:', parsedState);
              setTimeout(function () {
                atcBtn.textContent = strings.addToCart || 'Add to cart';
              }, 3000);
              return;
            }

            atcBtn.classList.remove('is-loading');
            atcBtn.classList.add('is-added');
            atcBtn.textContent = strings.addedToCart || '\u2713 Added';

            // Dawn pattern: publish cartUpdate first, then renderContents
            if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'es-wishlist',
                productVariantId: variantId,
                cartData: parsedState,
              });
            }

            if (cartDrawer && parsedState.sections && typeof cartDrawer.renderContents === 'function') {
              cartDrawer.renderContents(parsedState);
            }

            // Update header cart count by reading the live bubble after render
            var counter = document.getElementById('es-cart-count');
            if (counter) {
              var bubbleCount = document.querySelector('.cart-count-bubble span[aria-hidden="true"]');
              if (bubbleCount) {
                counter.textContent = bubbleCount.textContent;
              }
            }

            setTimeout(function () {
              atcBtn.classList.remove('is-added');
              atcBtn.textContent = strings.addToCart || 'Add to cart';
            }, 2000);
          })
          .catch(function (err) {
            console.error('[es-wishlist] cart/add failed:', err);
            atcBtn.classList.remove('is-loading');
            atcBtn.textContent = strings.tryAgain || 'Try again';
            setTimeout(function () {
              atcBtn.textContent = strings.addToCart || 'Add to cart';
            }, 3000);
          });
        return;
      }
    });
  }

  // Run
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', loadWishlist);
  } else {
    loadWishlist();
  }
})();
